import { create} from "zustand"
import CanvasInputListener from "../logic/CanvasInputListener";
import CommandStack from "../logic/CommandStack";
import SceneDocumentManager from "../logic/SceneDocumentManager";
import IAppDataProvider from "../services/bimVisualizerApi/appDataProviders/IAppDataProvider";

export interface ServicesState
{
    canvasInputListener: CanvasInputListener,
    commandStack: CommandStack,
    sceneDocumentManager: SceneDocumentManager 
    dataProvider: IAppDataProvider | null;
    setDataProvider: (dataProvider: IAppDataProvider) => void;
}

export const useServicesState = create<ServicesState>()(
    (set) => ({
        canvasInputListener: new CanvasInputListener(),
        commandStack: new CommandStack(),
        sceneDocumentManager: new SceneDocumentManager(),
        dataProvider: null,

        setDataProvider: (dataProvider: IAppDataProvider) => set({ dataProvider }),
    })
);


